import { SWITCH_PROVIDER_SET_PROVIDER_LIST } from '../actions/providerListActions';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

export default function reducer(state = [], action) {
  switch (action.type) {
    case SWITCH_PROVIDER_SET_PROVIDER_LIST:
      return action.payload;
    case LOGOUT_ACTION:
      return [];
    default:
      return state;
  }
}
